import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-green-800 via-green-700 to-emerald-700 pt-8 pb-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pb-8 border-b border-emerald-600">
          {/* Colonne 1 - À propos */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">À propos de SIND</h3>
            <p className="text-emerald-100 text-sm">
              SIND est une plateforme de cartographie des dépôts pharmaceutiques du Niger,
              développée en partenariat entre l'ANRP et Lafia Iyali.
            </p>
          </div>

          {/* Colonne 2 - Liens utiles */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Liens utiles</h3>
            <ul className="space-y-2">
              <li>
                <a 
                  href="https://cnsp.ne/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-emerald-100 hover:text-white text-sm transition-colors flex items-center gap-2"
                >
                  Présidence/CNSP
                </a>
              </li>
              <li>
                <a 
                  href="https://www.primature.ne/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-emerald-100 hover:text-white text-sm transition-colors"
                >
                  Primature
                </a>
              </li>
              <li>
                <a 
                  href="https://www.sante.gouvne.org/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-emerald-100 hover:text-white text-sm transition-colors"
                >
                  Ministère de la Santé
                </a>
              </li>
            </ul>
          </div>

          {/* Colonne 3 - Contact */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-2 text-emerald-100 text-sm">
              <li>ANRP</li>
              <li>Rue de la Santé</li>
              <li>BP: 817 Niamey - Niger</li>
              <li>Tél: (+227) 89 68 81 84</li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-6 text-center">
          <p className="text-emerald-100 text-sm">
            © 2025 ANRP. Tous droits réservés. | Développé par{' '}
            <a 
              href="https://aydees.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-white font-medium hover:text-emerald-200 transition-colors hover:underline"
            >
              Aydees
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;